/* eslint-disable camelcase */
const DesksUtilization = ({
  databoxes: { percent_avg_utilization, avg_utilization, avg_vacant, percent_max_utilization, max_utilization },
}) =>
  `The average utilisation (desks physically occupied or exhibiting signs of life) was ${percent_avg_utilization}%
   (${avg_utilization} utilised desks and ${avg_vacant} vacant desks),
   with a peak utilisation of ${percent_max_utilization}% (${max_utilization}).`;

export default DesksUtilization;
